var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('figure',{attrs:{"id":"icone-localizacao"}},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"IconeLocalizacao","src":require("@/assets/images/place.png")}})])
}]

export { render, staticRenderFns }